import * as React from 'react';
import classnames from 'classnames';
import { JSBridge, wechat } from '@iyunbao/utils';

import {
  BaseWidgetProps,
} from '../utils/type';

export interface ShareProps {
  title: string;
  desc: string;
  imgUrl: string;
  link?: string;
}

export interface PageProps extends BaseWidgetProps {
  title?: string;
  share?: ShareProps;
  className?: string;
}

const Page = (props: PageProps) => {
  const {
    prefixCls = 'crm-page',
    share,
    children,
    title,
    className,
    style = {},
  } = props;

  if (title && typeof title === 'string') {
    JSBridge.ready(() => {
      JSBridge.setTitle(title);
    });
  }

  if (share && Object.prototype.toString.call(share) === '[object Object]') {
    Object.keys(share).length > 0 && wechat.addShare(share);
  }

  const cls = classnames(prefixCls, className);

  return (
    <div className={cls} style={style}>
      {children}
    </div>
  );
};

export default Page;
